import React from 'react';
import { Container } from '@material-ui/core';
// routes
import { PATH_DASHBOARD } from '../../app';
// components
import { Page, HeaderBreadcrumbs } from '../../components';
import { ShopForm } from './ShopForm';

const BREADCRUMB_LINKS = [
  { name: 'Dashboard', href: PATH_DASHBOARD.root },
  { name: 'Shops list', href: PATH_DASHBOARD.shops.list },
  { name: 'Shop' },
];

export const ShopUpdate: React.FC = (): JSX.Element => (
  <Page title="Shops: Edit shop | Minimal-UI">
    <Container maxWidth="lg">
      <HeaderBreadcrumbs
        heading="Edit shop"
        links={BREADCRUMB_LINKS}
      />
      <ShopForm />
    </Container>
  </Page>
);
